import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'

import { PreOrderFetchAPI } from '../../api/Paymentpost/PreOrder';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';

import Swal from "sweetalert2";
import imgPreOrder from '../..//components/PaymentPost/img/preOrder.png'
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import { GiPlayerTime } from 'react-icons/gi';
import Empty from '../../utils/Empty';
import refund from '../img/icons/refund.png'
import ModalDivisionequalparts from '../Modals/OrderDivisions/ModalDivisionequalparts';
import ModalDivisionByProduct from '../Modals/OrderDivisions/ModalDivisionByProduct';
import ModalDetailPreOrder from '../Modals/ModalDetailPreOrder';
import ModalDivisionByProductPart from '../Modals/OrderDivisions/ModalDivisionByProductPart';
import './DivisionModal.css';

function ModalDivisionPreOrder({ order, getAll, onPendingDelete, codeParthner, resetInputs, orderNumberNow, getOrderNumber }) {
    const [showDivision, setShowDivision] = useState(false);

    return (
        <>
            <button className='precuenta-btn-secondary  btn-sm px-2 py-1'
                onClick={() => (setShowDivision(true))} title='Dividir precuenta'>
                <small>
                    <i class="fa-solid fa-divide"></i>
                </small>

            </button>



            <Modal
                show={showDivision}
                size="xl"
                onHide={() => setShowDivision(false)}
                aria-labelledby="example-custom-modal-styling-title"
                centered
                dialogClassName="sp-div-dialog"
                contentClassName="sp-div-content"
            >
                <Modal.Body className="sp-div">

                    {/* Header */}
                    <div className="sp-div__head">
                        {/* <div className="sp-div__badge"><i className="uil uil-arrows-resize"></i></div> */}
                        <h4 className="sp-div__title">Dividir precuenta</h4>
                        <button className="sp-div__x" type="button" aria-label="Cerrar" onClick={() => setShowDivision(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    {/* Cuerpo scrollable */}
                    <div className="sp-div__body">

                        {/* Detalle de la precuenta */}
                        {/* <div className="sp-div__detail"> */}
                            <ModalDetailPreOrder orderData={order}></ModalDetailPreOrder>
                        {/* </div> */}

                        {/* Acciones de división */}
                        <div className="sp-div__actionsect">
                            <div className="sp-div__sectlabel">¿Cómo deseas dividir la cuenta?</div>
                            <div className="sp-div__actions">
                                <ModalDivisionequalparts getOrderNumber={getOrderNumber} orderNumberNow={orderNumberNow} order={order} setShowDivision={setShowDivision} getAll={getAll} onPendingDelete={onPendingDelete} codeParthner={codeParthner} resetInputs={resetInputs}></ModalDivisionequalparts>
                                <ModalDivisionByProductPart getOrderNumber={getOrderNumber} orderNumberNow={orderNumberNow} order={order} setShowDivision={setShowDivision} getAll={getAll} onPendingDelete={onPendingDelete} codeParthner={codeParthner} resetInputs={resetInputs}></ModalDivisionByProductPart>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="sp-div__foot">
                        <button className="sp-div__btn sp-div__btn--cancel" onClick={() => setShowDivision(false)}>
                            <i className="uil uil-times-circle"></i> Cancelar
                        </button>
                    </div>

                </Modal.Body>
            </Modal>



        </>
    )
}

export default ModalDivisionPreOrder
